/*
 * Actions types
 */
export enum ThemeType {
  SET_THEME_RESQUEST = '@theme/SET_THEME_RESQUEST',
  SET_THEME_SUCCESS = '@theme/SET_THEME_SUCCESS',
}

export interface User {
  theme: string;
  identification_key: string;
  links: any;
}

/*
 * State Type
 */
export interface ThemeState {
  readonly theme: 'light' | 'dark' | undefined;
}
